import type { Owner } from '@/components/OwnedChip'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'

export interface Enrolment {
  id: number
  person_id: number
  person_name: string
  person_email: string | null
  person_archived: boolean
  course_id: number
  course_title: string
  status: EnrolmentStatus
  enrolled_on: string
  completed_on: string | null
  withdrawn_on: string | null
  score: string | null
  grade_label: string | null
  credits_earned: string | null
  owner: Owner | null
}

export const enrolmentStatuses = {
  enrolled: 'Enrolled',
  completed: 'Completed',
  failed: 'Failed',
  withdrawn: 'Withdrawn',
} as const
export type EnrolmentStatus = keyof typeof enrolmentStatuses
const variants = {
  enrolled: 'info',
  completed: 'success',
  failed: 'destructive',
  withdrawn: 'neutral',
} as const

export function EnrolmentBadge({ status }: { status: EnrolmentStatus }) {
  return <Badge variant={variants[status]}>{enrolmentStatuses[status]}</Badge>
}

export function EnrolmentGrade({ enrolment }: { enrolment: Enrolment }) {
  const label = enrolment.grade_label || enrolment.score
  if (enrolment.score === null) return label
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          className="h-auto p-0 font-normal hover:bg-transparent"
        >
          {label}
        </Button>
      </TooltipTrigger>
      <TooltipContent>Score {enrolment.score}</TooltipContent>
    </Tooltip>
  )
}
